import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import renderSection2 from './section2';
import renderSection8 from '../Projection/section8';

import styles from './index.module.scss';

function Farming(props) {
    document.title = "Фермерство";

    return (
    <main className={cn(styles.main, props.className, 'farming')} style={{overflow:"hidden"}}>
      <div className={styles.main1} />
      <img className={styles.cover} src={'/assets/eb82a550de40e3104c56d70fc743dbf0.png'} alt="alt text" />

      <div className={styles.flex_col}>
          {renderSection2(props)}
          {renderSection8(props)}
      </div>
    </main>
  );
}

Farming.propTypes = {
  className: PropTypes.string
};

export default Farming;
